import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  Popover,
  FormControl,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import preview_image from "../../../../assets/Heygen/GirlImageforHeygenAvatarPreview.png";
import InstaReel from "../../../../assets/Heygen/InstaReel.png";
import Landscapre from "../../../../assets/Heygen/Landscape.png";
import square from "../../../../assets/Heygen/Squre.png";
import InstaPost from "../../../../assets/Heygen/InstaPost.png";

const customTextFieldStyles = {
  "& .MuiInputLabel-root": {
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    color: "rgba(255, 255, 255, 0.80)",
    "&.Mui-focused": {
      color: "rgba(255, 255, 255, 0.80) !important",
    },
  },
  "& .MuiInputBase-input": {
    color: "#FFFFFF",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(255, 255, 255, 0.80)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(255, 255, 255, 0.80)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(255, 255, 255, 0.80) !important",
    },
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.80) !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.80) !important",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.40)",
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.40)", // New color
  },
};
const Resolution = [
  { id: 3, width: 426, height: 240, value: "240p (426 X 240)" },
  { id: 4, width: 854, height: 480, value: "360p (854 X 480)" },
  { id: 5, width: 640, height: 360, value: "480p (640 X 360)" },
  { id: 1, width: 1280, height: 720, value: "720p (1280 X 720)" },
  { id: 2, width: 1920, height: 1080, value: "1080p (1920 X 1080)" },
];

const SocialMediaPresets = [
  {
    id: 6,
    width: 1080,
    height: 1920,
    value: "1080 X 1920",
    plateform: "Instagram reel",
    ratio: { x: 1, y: 1.78 },
    img: InstaReel,
  },
  {
    id: 7,
    width: 1920,
    height: 1080,
    value: "1920 X 1080",
    plateform: "Landscape video",
    ratio: { x: 1.78, y: 1 },
    img: Landscapre,
  },
  {
    id: 8,
    width: 1080,
    height: 1080,
    value: "1080 X 1080",
    plateform: "Square",
    ratio: { x: 1, y: 1 },
    img: square,
  },
  {
    id: 9,
    width: 1080,
    height: 1350,
    value: "1080 X 1350",
    plateform: "Instagram post",
    ratio: { x: 1, y: 1.25 },
    img: InstaPost,
  },
];

const DimensionsSettings = (props) => {
  const {
    heygenVideoWidth,
    heygenVideoHeight,
    setHeygenVideoWidth,
    setHeygenVideoHeight,
    selectedVideoResolution,
    setSelectedVideoResolution,
  } = useWorkspace();

  // Only update from props if they are provided (from VideoGenerate.jsx)
  React.useEffect(() => {
    if (props.width && props.height) {
      setHeygenVideoWidth(props.width);
      setHeygenVideoHeight(props.height);
      
      const matchedResolution = Resolution.find(
        (res) => res.width === props.width && res.height === props.height
      );

      const matchedPreset = SocialMediaPresets.find(
        (preset) => preset.width === props.width && preset.height === props.height
      );

      setSelectedVideoResolution(matchedResolution || matchedPreset || null);
    }
  }, [props.width, props.height]);

  const [allAvalaibleResolution, setAllAvalaibleResolution] =
    useState(Resolution);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dropDownDisable, setDeopDownDisable] = useState(false);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const HandleCustomHeygenVideoWidth = (e) => {};

  const HandleCustomHeygenVideoHeight = (e) => {};

  const handleSelectResolution = (resolution) => {
    if (resolution?.plateform) {
      setSelectedVideoResolution(resolution);
      setHeygenVideoWidth(resolution?.width);
      setHeygenVideoHeight(resolution?.height);
    } else {
      setSelectedVideoResolution(resolution);
      setHeygenVideoWidth(resolution?.width);
      setHeygenVideoHeight(resolution?.height);
      setAnchorEl(null);
    }
    // Only call props.setWidth/setHeight if they're provided (from VideoGenerate.jsx)
    if (props.setWidth && typeof props.setWidth === 'function' && 
        props.setHeight && typeof props.setHeight === 'function') {
      props.setWidth(resolution.width);
      props.setHeight(resolution.height);
    }
  };

  return (
    <Box sx={{ padding: "20px 20px 0px 0px", color: "white" }}>
      <Box sx={{ display: "flex", flexDirection: "row", columnGap: "12px" }}>
        <Typography>Advanced video settings</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Box>
            <Box
              sx={{
                mt: 3,
                width: "100%",
                display: "flex",
                flexDirection: "row",
                columnGap: "20px",
              }}
            >
              <Box>
                <Typography sx={{ marginBottom: 2 }}>
                  Custom video output dimensions
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "20px",
                  }}
                >
                  <TextField
                    disabled={true}
                    onChange={(e) => {
                      HandleCustomHeygenVideoWidth(e);
                    }}
                    type="number"
                    value={heygenVideoWidth}
                    id="outlined-basic"
                    label="Width*"
                    variant="outlined"
                    sx={customTextFieldStyles}
                    style={{
                      width: "146px",
                      height: "56px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                      marginBottom: "36px",
                    }}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*", // For whole numbers
                      min: 0, // Minimum value
                    }}
                  />
                  <TextField
                    disabled={true}
                    onChange={(e) => {
                      HandleCustomHeygenVideoHeight(e);
                    }}
                    type="number"
                    value={heygenVideoHeight}
                    id="outlined-basic"
                    label="Height*"
                    variant="outlined"
                    sx={customTextFieldStyles}
                    style={{
                      width: "146px",
                      height: "56px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                      marginBottom: "36px",
                    }}
                  />
                </Box>
              </Box>
              <Box>
                <Typography sx={{ marginBottom: 2 }}>Select preset</Typography>
                <FormControl>
                  <Button
                    onClick={handleOpen}
                    sx={{
                      color: selectedVideoResolution?.value
                        ? "rgba(255, 255, 255, 1)"
                        : "rgba(202, 196, 208, 1)",
                      backgroundColor: "#2F355F",
                      borderRadius: "8px",
                      height: "56px",
                      minWidth: "200px",
                      textTransform: "none",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      "&:hover": {
                        backgroundColor: "#373E6D",
                      },
                    }}
                  >
                    {selectedVideoResolution?.value}
                    <ArrowDropDownIcon
                      sx={{
                        color: selectedVideoResolution?.value
                          ? "rgba(255, 255, 255, 1)"
                          : "rgba(202, 196, 208, 1)",
                        marginLeft: "auto",
                      }}
                    />
                  </Button>

                  <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    sx={{
                      "& .MuiPaper-root": {
                        backgroundColor: "#2F355F",
                        color: "white",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                        maxHeight: "300px",
                        width: "180px",
                        marginTop: "4px",
                      },
                    }}
                  >
                    <Box sx={{ overflowY: "auto", maxHeight: 250 }}>
                      {allAvalaibleResolution?.map((resolution, index) => (
                        <MenuItem
                          key={index + 1}
                          onClick={() => handleSelectResolution(resolution)}
                          sx={{
                            "&:hover": { backgroundColor: "#373E6D" },
                            "&.Mui-selected": { backgroundColor: "#373E6D" },
                            py: 1,
                            fontSize: 14,
                          }}
                        >
                          {resolution?.value}
                        </MenuItem>
                      ))}
                    </Box>
                  </Popover>
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ marginBottom: 2 }}>Social media presets</Typography>
        {/* <Box sx={{display:"flex", flexDirection:"row", gap:"20px", flexWrap:"wrap"}}>
            {
              SocialMediaPresets?.map((ele, index)=>{
                return (
                  <Box onClick={(ele)=>handleSelectResolution(ele)} sx={{cursor:"pointer", width:"285px", height:"308px", border:"1px solid rgba(255, 255, 255, 0.10)", borderRadius:"16px", padding:"20px"}}>
                    <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                      <Box sx={{width: "70%",
                                height: "70%", // Leaves 20% for the text section
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"}}> 
                      <img src={ele?.img} alt={"avatarPreview"} style={{objectFit:"contain", width:"100%", height:"100%"}}/>
                      </Box> 
                      <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", }}>
                    <Typography sx={{fontFamily:"Inter", fontSize:"14px", fontStyle:"normal", fontWeight:600, lineHeight:"20px", letterSpacing:"0.1px", color:"#CAC4D0"}}>{ele?.plateform}</Typography>
                    <Typography sx={{fontFamily:"Inter", fontSize:"12px", fontStyle:"normal", fontWeight:400, lineHeight:"20px", letterSpacing:"0.1px", color:"#CAC4D0"}}>{ele?.value}</Typography>
                      </Box>
                      </Box>
                  </Box>
                )
              })
            }
          </Box> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          {SocialMediaPresets?.map((ele, index) => (
            <Box
              key={index}
              onClick={() => handleSelectResolution(ele)}
              sx={{
                cursor: "pointer",
                width: "285px",
                height: "308px",
                border:
                  selectedVideoResolution?.id == ele?.id
                    ? "1px solid rgba(255, 255, 255, 0.30)"
                    : "1px solid rgba(255, 255, 255, 0.10)",
                borderRadius: "16px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                backgroundColor:
                  selectedVideoResolution?.id == ele?.id ? "#282D51" : "none",
                "&:hover": {
                  backgroundColor:
                    selectedVideoResolution?.id != ele?.id ? "#282D51" : "none",
                },
              }}
            >
              <Box
                sx={{
                  flex: 1, // Takes up all available space except what's needed for text
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden", // Ensures image doesn't overflow
                  position: "relative",
                  width: "100%",
                }}
              >
                <img
                  src={ele?.img}
                  alt={"avatarPreview"}
                  style={{
                    objectFit: "contain",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    width: "auto",
                    height: "auto",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    color: "#CAC4D0",
                  }}
                >
                  {ele?.plateform}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    color: "#CAC4D0",
                  }}
                >
                  {ele?.value}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default DimensionsSettings;
